<template>
  <FormSection title="Attachment(s)">
    <div class="attachments-section">
      <!-- Existing Attachments -->
      <div class="attachments-list">
        <ul class="attachment-items">
          <li v-for="item in filteredAttachments" :key="item.ID" class="attachment-item">
            <a :href="item.APAT_FilePath + item.APAT_EnrolFileName + item.APAT_EnrolFileExt" target="_blank" class="attachment-link">
              <i class="fa fa-file"></i>
              {{ item.APAT_EnrolFileName }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Upload New Attachment -->
      <div class="upload-section">
        <div class="upload-controls">
          <span class="upload-label">Add Attachment:</span>
          <div class="upload-input-group">
            <input class="form-control upload-input" type="file" id="new-attachment-input" multiple />
            <button class="el-button el-button--secondary upload-button" @click="handleUpload">Upload</button>
          </div>
        </div>
        <div class="upload-controls">
          <span class="upload-label">Attachment Type:</span>
          <input class="form-control" type="text" v-model="fileUploadType" />
        </div>
      </div>
    </div>
  </FormSection>
</template>

<script>
import FormSection from './FormSection.vue'

export default {
  name: 'AttachmentsSection',
  components: {
    FormSection,
  },
  props: {
    attachmentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fileUploadType: 'Supporting Information',
    }
  },
  computed: {
    filteredAttachments() {
      return this.attachmentList.filter(item => item.APAT_UploadType !== 'Declare & Agreement')
    },
  },
  methods: {
    handleUpload() {
      const inputFiles = document.querySelector('#new-attachment-input')?.files
      this.$emit('file-uploaded', inputFiles, this.fileUploadType)
    },
  },
}
</script>

<style scoped>
.attachments-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.attachments-list {
  border: 1px solid #ddd;
  border-radius: 5px;
  background: white;
}

.attachment-items {
  list-style: none;
  margin: 0;
  padding: 20px;
}

.attachment-item {
  margin-bottom: 10px;
}

.attachment-link {
  color: #426dff;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.attachment-link:hover {
  background-color: #f8f9fa;
  text-decoration: none;
}

.upload-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.upload-controls {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  align-items: center;
}

.upload-label {
  white-space: nowrap;
  font-weight: 500;
}

.upload-input-group {
  display: flex;
  gap: 10px;
}

.upload-input {
  flex: 1;
  margin: 0;
}

.upload-button {
  white-space: nowrap;
}

.form-control {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .upload-controls {
    grid-template-columns: 1fr;
    row-gap: 0.5rem;
  }

  .upload-input-group {
    flex-direction: column;
  }
}
</style>
